import { createAppAsyncThunk } from '@/store/thunks/createAppAsyncThunk';

// eslint-disable-next-line @typescript-eslint/no-invalid-void-type -- void
export const resendPhoneCodeThunk = createAppAsyncThunk<void>(
  'auth/resendPhoneCode',
  async(_, { extra: { authService } }) => {
    await authService.resendPhoneCode();
  }
);
